<script>
    export let viewType = "";
    export let classNames = "";
</script>

<!--src/components/View.svelte-->
<div class="{viewType} {classNames}">
    <slot />
</div>

<style>
    div {
        background-color: var(--backgroundColorLight);
        width: 100%;
        margin: auto;
        display: flex;
        flex-direction: column;
        flex: 1 2 auto;
    }
    .page-wrap {
        max-width: 1024px;
        margin: auto;
    }

    .card-wrap {
        padding: 24px;
        width: 95%;
        margin: 0px;
        border-radius: 6px;
    }

    .v-center-h-center {
        justify-content: center;
        align-items: center;
    }
</style>
